const tools = require('form/tools')();

exports.state = function (completeConfig, types = a => null, language) {
   
    return makeState();

    function makeState() {

        const fields = completeConfig.fields.map(field => {
            return wrapConfig(field);
        });

        const minPage = fields.reduce((min, field) => {
            const page = Number(field.config.page);
            if (page === page && min > page) return page;
            else return min;
        }, Infinity);
        const maxPage = fields.reduce((max, field) => {
            const page = Number(field.config.page);
            if (page === page && max < page) return page;
            else return max;
        }, 0);

        var state = {
            fields: fields,
            pages: wrapConfig(completeConfig.pages || {
                defaultValue: completeConfig.startingPage || minPage,
                numberOfPages: maxPage + 1,
                maxPage, minPage,
            }),
        };

        return tools.merge(state, {
            sharedScope: {
                getState: tools.getState.bind(null, state)
            },
            globalState: tools.makeGlobalState(state, completeConfig),
        });
    }


    function wrapConfig(config) {
        return {
            id: config.id,
            config: config,
            state: makeStateObject(config),
            validators: mergeValidators(config)
        };
    }


    function mergeValidators(config) {
        return [
            ...(config.validators || []),
            ...getFromType("validators", config, [])
        ];
    }

    function getFromType(key, config, fallback) {
        var type = types(config.type);
        if (type && type[key]) return type[key];
        else return fallback;
    }

    function getValidatorsFromKeys(keys = []) {
        var validators = require('form/validators')(language);
        return keys.reduce((list, key) => {
            var validator = validators.get(key);
            if (validator) return list.concat(validator());
            else return list;
        }, []);
    }



    function makeStateObject(config) {
        return mergeExtraState({
            value: notUndefined(config.defaultValue, ''),
            api: {
                running: false,
                time: 0,
                error: "",
                result: {}
            },
            status: "never-focused",
            errors: [],
            localErrors: [],
        }, config);
    }


    function mergeExtraState(object, config) {
        const extraFields = config.extraState || {};

        Object.keys(extraFields).forEach(key => {
            object[key] = JSON.parse(JSON.stringify(extraFields[key]));
        });

        object.liveReference = config.liveReference;

        return object;
    }


    function notUndefined(value, fallback) {
        if (value === undefined) return fallback;
        else return value;
    }

};


